import { useEffect } from "react";

export function addBodyClasses(classes) {
  return () => useEffect(() => {
    classes.forEach(c => document.body.classList.add(c))
    return () => { classes.forEach(c => document.body.classList.remove(c)); }
  });
}
